import * as React from "react";
import { Button, GenerationTimeline } from "@aisquare/ui";
import { Section, VariantBlock } from "../lib/Section";

export function GenerationTimelineDemo() {
  // `runId` remounts the timeline so it restarts from phase 0 on demand.
  const [runId, setRunId] = React.useState(0);
  const [done, setDone] = React.useState(false);

  return (
    <Section
      id="generation-timeline"
      title="GenerationTimeline"
      description="System-driven phase list for long AI generation waits. Default script ships as DEFAULT_GENERATION_PHASES; pass `phases` for a custom one. Tokenised; reduced-motion safe."
    >
      <VariantBlock label="Default script">
        <div className="w-80 rounded-2xl border border-border bg-card p-5">
          <GenerationTimeline
            key={runId}
            onComplete={() => setDone(true)}
          />
          <div className="mt-4 flex items-center gap-3 border-t border-border pt-3">
            <Button
              size="sm"
              variant="outline"
              onClick={() => {
                setDone(false);
                setRunId((n) => n + 1);
              }}
            >
              Restart
            </Button>
            <span className="text-xs text-muted-foreground">
              {done ? "Complete" : "Running…"}
            </span>
          </div>
        </div>
      </VariantBlock>

      <VariantBlock label="Custom phases" caption="phases prop">
        <div className="w-80 rounded-2xl border border-border bg-card p-5">
          <GenerationTimeline
            key={`custom-${runId}`}
            phases={[
              { name: "Scanning sources", sub: "Reading 12 documents", duration: 1500 },
              { name: "Drafting summary", duration: 3500, hasProgress: true },
              { name: "Finalising", sub: "Almost there", duration: 1200 },
            ]}
          />
        </div>
      </VariantBlock>
    </Section>
  );
}
